var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph_button graph_card",attrs:{"data-disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.text==null)?_c('GraphIcon',{attrs:{"icon":_vm.icon}}):_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }